import { authFetch } from "../../api";



export const getNotifications = async (requestData) => {
  try {
    const response = await authFetch("std-notification/byuser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch notification data :", err.message);
  }
};





export const readAllNotifications = async (requestData) => {
  try {
    const response = await authFetch("std-notification/read-all", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch notification data :", err.message);
  }
};




export const deleteAllNotifications = async (requestData) => {
  try {
    const response = await authFetch("std-notification/delete-all", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't delete notification :", err.message);
  }
};


export const getNotificationCount = async (requestData) => {
  try {
    const response = await authFetch("std-notification/notification-count", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch notification count :", err.message);
  }
};


